import request from "@/utils/request";

export function getDetail(data) {
	return request({
		url: '/app/notify/detail',
		method: 'post',
		data
	})
}
export function markRead(data) {
	return request({
		url: '/app/notify/read',
		method: 'post',
		data
	})
}
